module.exports = __webpack_public_path__ + "assets/img/f8f8b3f93ce39a8671dbb1b7409962c3.png";